import axios from 'axios'
import type { AxiosError } from 'axios'

export const nordyAxios = axios.create({
  withCredentials: true,
  withXSRFToken: true,
  baseURL: import.meta.env.VITE_NORDY_API_URL,
  headers: {
    'x-origin-url': window.location.href
  }
})

//!nordy - 401 발생 시 로그인 모달 자동 노출 (쿠키 만료/관리자 무효화 대응)
//   - /auth 및 /v1/auth 엔드포인트는 비로그인 상태 확인에도 쓰이므로 제외 (무한 루프 방지)
//   - openLoginModal 자체에 isDialogOpen 가드가 있어 중복 호출되어도 모달은 1개만 뜸
nordyAxios.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    if (error.response?.status === 401) {
      const url = error.config?.url ?? ''
      const pathname = new URL(url, window.location.origin).pathname
      const isAuthEndpoint = /^\/(?:v1\/)?auth(?:\/|$)/i.test(pathname)
      if (!isAuthEndpoint) {
        try {
          const { useNordyModalStore } =
            await import('@/nordy/store/nordyModalStore')
          useNordyModalStore().openLoginModal()
        } catch (e) {
          console.error('Failed to open login modal on 401:', e)
        }
      }
    }
    return Promise.reject(error)
  }
)
